import { Action } from "redux";

export const APP_INIT_ACTION = "COMMON:APP_INIT_ACTION";

export interface AppInitAction extends Action {
  type: typeof APP_INIT_ACTION;
}

export const appInitAction = (): AppInitAction => ({
  type: APP_INIT_ACTION,
});
